const verifyBeforeYouTrust = {
  slug: 'verify-before-you-trust',
  title: 'Verify before you trust a caller',
  description:
    'How to hang up and call back on official numbers, check your bank app, and confirm whether a call is legitimate.',
  category: 'scams',
  guideType: 'guide',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['red-flags', 'caller-id-spoofing', 'common-phone-scams'],
  sections: [
    {
      type: 'paragraph',
      text: 'Verification means using a channel you control — not the phone number or link the caller gave you.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Hang up and call back',
    },
    {
      type: 'list',
      items: [
        'Find the official number on the back of your card, on a paper statement, or on the company’s verified website',
        'Use a different phone if possible in case they stayed on the line',
        'Do not use a number the caller texted or emailed you',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Check in your bank or service app',
    },
    {
      type: 'paragraph',
      text: 'Log in through the app or website you normally use. Look for messages or alerts there instead of trusting what the caller said.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Take your time',
    },
    {
      type: 'paragraph',
      text: 'Real organizations allow you to call back later. Scammers punish delay because their story falls apart.',
    },
    {
      type: 'tip',
      text: 'Search the number on WhoDatNumber to see if others reported similar calls.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default verifyBeforeYouTrust;

